var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './Pagination.module.scss';
import { v4 as uuid } from 'uuid';
import { ArrowLeft, ArrowRight } from '../../assets/icons';
import cx from 'classnames';
import { Input } from '../Input/Input';
import { Button } from '../Button/Button';
import { Select } from '../Select/Select';
var perPageOptions = [
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '15', value: '15' },
    { label: '20', value: '20' },
    { label: '25', value: '25' },
];
var Pagination = function (_a) {
    var _b, _c;
    var total = _a.total, current = _a.current, className = _a.className, id = _a.id, dataId = _a.dataId, onChange = _a.onChange, _d = _a.perPage, perPage = _d === void 0 ? '10' : _d, onPerPage = _a.onPerPage, _e = _a.showPerPage, showPerPage = _e === void 0 ? false : _e;
    var _f = useState([]), pages = _f[0], setPages = _f[1];
    var _g = useState(''), goToPage = _g[0], setGoToPage = _g[1];
    var allPages = Array.from({ length: Number(total) }).map(function (n, i) { return i + 1; });
    var selectedPerPageOption = perPageOptions.find(function (option) { return option.value === perPage; }) || {
        label: '10',
        value: '10',
    };
    var isValidPage = function () { return allPages.some(function (p) { return "".concat(p) == goToPage; }); };
    var getPages = function () {
        var atTheEnd = +total - +current > 5;
        var removeCount = atTheEnd ? +current - 3 : +total - 8;
        allPages.splice(1, removeCount);
        if (allPages.length > 8)
            allPages.splice(4, Number(allPages.length) - 5, '...');
        return allPages;
    };
    useEffect(function () {
        setPages(getPages());
    }, [total, current]);
    var onGoToPage = function () {
        isValidPage() && onChange(goToPage);
        setGoToPage('');
    };
    var onPrevPage = function () {
        var prevPage = +current - 1;
        onChange(prevPage);
    };
    var onNextPage = function () {
        var nextPage = +current + 1;
        onChange(nextPage);
    };
    var renderPages = function () {
        return pages.map(function (p) { return (_jsx("li", __assign({ className: "".concat(styles.Page, " ").concat(p == current ? styles.Active : ''), onClick: function () { return p !== '...' && onChange(p); } }, { children: p }), uuid())); });
    };
    return (_jsxs("section", __assign({ id: id, "data-testid": dataId, className: "".concat(styles.Pagination, " ").concat(className ? className : '') }, { children: [_jsxs("section", __assign({ className: styles.Current }, { children: [_jsxs("span", __assign({ className: styles.PageNumberWrapper, "data-testid": 'current-page' }, { children: ["Pages", _jsx("span", __assign({ className: styles.PageNumber }, { children: current })), " of ", _jsx("span", __assign({ className: styles.PageNumber }, { children: total }))] })), showPerPage && (_jsx(Select, { dropUp: true, noMargin: true, small: true, options: perPageOptions, selected: [selectedPerPageOption], onChange: onPerPage }))] })), _jsxs("section", __assign({ className: styles.PagesBox }, { children: [_jsxs("span", __assign({ onClick: onPrevPage, className: cx(styles.ArrowButtons, (_b = {},
                            _b[styles.Disabled] = current === 1,
                            _b)) }, { children: [_jsx(ArrowLeft, {}), _jsx("span", __assign({ className: styles.Previous }, { children: "Prev" }))] })), _jsx("ul", __assign({ className: styles.Pages, "data-testid": 'pagination-pages' }, { children: renderPages() })), _jsxs("span", __assign({ onClick: onNextPage, className: cx(styles.ArrowButtons, (_c = {},
                            _c[styles.Disabled] = current === total,
                            _c)) }, { children: [_jsx("span", __assign({ className: styles.Next }, { children: "Next" })), _jsx(ArrowRight, {})] }))] })), _jsx("section", __assign({ className: styles.PageSelector }, { children: _jsxs("section", __assign({ className: styles.GoTo }, { children: ["Go to page", _jsx(Input, { className: styles.GoToInput, placeholder: '123', value: goToPage, small: true, noMargin: true, dataId: 'go-to-input', onChange: setGoToPage, onEnter: onGoToPage }), _jsx(Button, { className: styles.GoToButton, title: 'Go', small: true, dataId: 'go-to-button', disabled: !isValidPage(), onClick: onGoToPage })] })) }))] })));
};
Pagination.propTypes = {
    total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    current: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
Pagination.defaultProps = {
    total: 1,
    current: 1,
};
export { Pagination };
//# sourceMappingURL=Pagination.js.map